import styled from 'styled-components';
import { Layout } from 'antd';

export const StyledFooter = styled(Layout.Footer)`
  position: sticky;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  padding: ${({ theme }) => theme.spacing.space_5}};
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
